import { render, staticRenderFns } from "./IBeaconMessageTable.vue?vue&type=template&id=316b4a64&scoped=true"
import script from "./IBeaconMessageTable.vue?vue&type=script&lang=js"
export * from "./IBeaconMessageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b4a64",
  null
  
)

export default component.exports